import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './user-cash-back-deal.reducer';

export const UserCashBackDealDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const userCashBackDealEntity = useAppSelector(state => state.userCashBackDeal.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="userCashBackDealDetailsHeading">
          <Translate contentKey="tycheApp.userCashBackDeal.detail.title">UserCashBackDeal</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tycheApp.userCashBackDeal.id">Id</Translate>
            </span>
          </dt>
          <dd>{userCashBackDealEntity.id}</dd>
          <dt>
            <Translate contentKey="tycheApp.userCashBackDeal.deal">Deal</Translate>
          </dt>
          <dd>{userCashBackDealEntity.deal ? userCashBackDealEntity.deal.id : ''}</dd>
          <dt>
            <Translate contentKey="tycheApp.userCashBackDeal.userCashBack">User Cash Back</Translate>
          </dt>
          <dd>{userCashBackDealEntity.userCashBack ? userCashBackDealEntity.userCashBack.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/user-cash-back-deal" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/user-cash-back-deal/${userCashBackDealEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default UserCashBackDealDetail;
